export enum ProjectActionType {
    UPLOAD_FILE,
    OPEN_PROCESS,
    DOWNLOAD_FILE,
    CREATE_SUBSET,
    CONNECT_DEPT,
    IKEOFFICE_AUTH,
}
